var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Dropdown, getTestId, isValidObject, StateConfigContext } from '@airtel/air-design-system';
import { merge } from 'lodash';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { View } from 'react-native';
import { simDeclarationConfig } from '../SimDeclarationConfig';
import { getSimDeclarationStyles } from '../SimDeclarationStyles';
import { generateDropdownDataWithNumber, generateSimProviderDropDownList, getTotalSelectedSimCount } from '../SimDeclarationUtils';
export var SimProviderDetailsForm = props => {
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _useMemo = useMemo(() => merge({}, simDeclarationConfig, props), [simDeclarationConfig, props]),
    dropdownsDataProps = _useMemo.dropdownsDataProps,
    providerDetails = _useMemo.providerDetails,
    isConnectionSelected = _useMemo.isConnectionSelected,
    selectedTotalConnectionCount = _useMemo.selectedTotalConnectionCount,
    showAddProviderButton = _useMemo.showAddProviderButton,
    addProviderButtonProps = _useMemo.addProviderButtonProps,
    testID = _useMemo.testID,
    updateProviderDetails = _useMemo.updateProviderDetails,
    handleAddProviderButtonPress = _useMemo.handleAddProviderButtonPress,
    onUserAction = _useMemo.onUserAction;
  var simDeclarationStyles = getSimDeclarationStyles();
  var providerName = dropdownsDataProps.providerName,
    simCountPerProvider = dropdownsDataProps.simCountPerProvider;
  var _useState = useState(providerName),
    providerNameState = _useState[0],
    setProviderNameState = _useState[1];
  var _useState2 = useState(simCountPerProvider),
    simCountPerProviderState = _useState2[0],
    setSimCountPerProviderState = _useState2[1];
  useEffect(() => {
    setProviderNameState(prev => Object.assign(Object.assign({}, prev), providerName));
  }, [JSON.stringify(providerName)]);
  useEffect(() => {
    setSimCountPerProviderState(prev => Object.assign(Object.assign({}, prev), simCountPerProvider));
  }, [JSON.stringify(simCountPerProvider)]);
  var getRemainingSimProviderDropDownList = useCallback(() => {
    return generateSimProviderDropDownList(providerNameState === null || providerNameState === void 0 ? void 0 : providerNameState.dropdownList, providerDetails);
  }, [selectedTotalConnectionCount, providerDetails]);
  var getRemainingSimCountDropDownList = useCallback(index => {
    return generateDropdownDataWithNumber(selectedTotalConnectionCount - getTotalSelectedSimCount(providerDetails, index), 1);
  }, [selectedTotalConnectionCount, providerDetails]);
  var onChangeProvider = _a => {
    var _b, _c;
    var args = __rest(_a, []);
    updateProviderDetails(args === null || args === void 0 ? void 0 : args.id, 'provider', (_b = args === null || args === void 0 ? void 0 : args[2]) === null || _b === void 0 ? void 0 : _b.value);
    var onChangeMetaData = providerNameState === null || providerNameState === void 0 ? void 0 : providerNameState.onChangeMetaData;
    isValidObject(onChangeMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id: 'simProvider'
    }, onChangeMetaData), {
      value: (_c = args === null || args === void 0 ? void 0 : args[2]) === null || _c === void 0 ? void 0 : _c.value
    }));
  };
  var onChangeCount = _a => {
    var _b, _c;
    var args = __rest(_a, []);
    updateProviderDetails(args === null || args === void 0 ? void 0 : args.id, 'count', parseInt((_b = args === null || args === void 0 ? void 0 : args[2]) === null || _b === void 0 ? void 0 : _b.value));
    var onChangeMetaData = simCountPerProviderState === null || simCountPerProviderState === void 0 ? void 0 : simCountPerProviderState.onChangeMetaData;
    isValidObject(onChangeMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id: 'simCount'
    }, onChangeMetaData), {
      value: parseInt((_c = args === null || args === void 0 ? void 0 : args[2]) === null || _c === void 0 ? void 0 : _c.value)
    }));
  };
  var onClearProvider = id => {
    updateProviderDetails(id, 'provider', '');
  };
  var onClearCount = id => {
    updateProviderDetails(id, 'count', null);
  };
  return _jsxs(_Fragment, {
    children: [providerDetails === null || providerDetails === void 0 ? void 0 : providerDetails.map((provider, index) => {
      var zIndex = 9999 - index;
      return _jsxs(View, Object.assign({
        style: [simDeclarationStyles.providerContent, {
          zIndex
        }]
      }, getTestId(testID, "provider_" + index), {
        children: [_jsx(Dropdown, Object.assign({}, providerNameState, {
          theme: theme,
          dropdownList: getRemainingSimProviderDropDownList(),
          onSelectedHandler: function onSelectedHandler() {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return onChangeProvider(Object.assign(Object.assign({}, args), {
              id: provider.id
            }));
          },
          style: [isConnectionSelected && simDeclarationStyles.providerNameInput, providerNameState.style, {
            zIndex
          }],
          clearInputOnBlur: true,
          onInputClear: () => onClearProvider(provider.id),
          position: "below",
          listMaxHeightPercentage: 30
        }, getTestId(testID, "dropdown_" + index))), _jsx(Dropdown, Object.assign({}, simCountPerProviderState, {
          theme: theme,
          dropdownList: getRemainingSimCountDropDownList(index),
          onSelectedHandler: function onSelectedHandler() {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }
            return onChangeCount(Object.assign(Object.assign({}, args), {
              id: provider.id
            }));
          },
          style: [simDeclarationStyles.noOfSimInput, simCountPerProviderState.style, {
            zIndex
          }],
          clearInputOnBlur: true,
          onInputClear: () => onClearCount(provider.id),
          position: "below",
          listMaxHeightPercentage: 30
        }, getTestId(testID, "simCount_" + index)))]
      }), provider.id);
    }), showAddProviderButton && _jsx(View, Object.assign({
      style: simDeclarationStyles.addProviderBtn
    }, {
      children: _jsx(Button, Object.assign({}, addProviderButtonProps, {
        theme: theme,
        style: [addProviderButtonProps.style, {
          zIndex: -1
        }],
        onPress: handleAddProviderButtonPress
      }, getTestId(testID, "addProviderButton")))
    }))]
  });
};